import React from 'react';
import { t } from '../../i18n';
import CustomButton from '../CustomButton/CustomButton.component';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DialogContentTextWrapper } from './ErrorPopup.style';

interface ErrorPopupProps {
  showErrorPopup: boolean;
  setShowErrorPopup(a: boolean): void;
  errorMessage: string;
}

const ErrorPopup: React.FC<ErrorPopupProps> = (props) => {
  const { showErrorPopup, setShowErrorPopup, errorMessage } = props;

  const handleClosePopup = () => {
    // TODO: handle close
    setShowErrorPopup(false);
  };

  return (
    <Dialog
      open={showErrorPopup}
      onClose={handleClosePopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t('general.alert')}</DialogTitle>
      <DialogContent>
        <DialogContentTextWrapper id="alert-dialog-description">
          {errorMessage}
        </DialogContentTextWrapper>
      </DialogContent>
      <DialogActions>
        <CustomButton
          title={t('general.ok')}
          variant="outlined"
          color="primary"
          onClick={handleClosePopup}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ErrorPopup;
